import {
    ApplyMessageActionRequest,
    ApplyMessageActionResponse,
    getServiceAsync,
    TFactories,
} from '../../../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../../../shared';

function createApplyMessageRequest(
    personaIds: string[],
    serviceFactory: TFactories
): ApplyMessageActionRequest {
    const personaIdsObj = personaIds.map(id => serviceFactory.itemId({ Id: id }));

    return {
        Ids: personaIdsObj,
        MessageAction: { Action: 'Restore' },
    };
}

export function restorePersonasOperation(
    personaIds: string[]
): Promise<ApplyMessageActionResponse> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'RestoreContacts',
            feature: Feature.RestoreDeletedContacts,
            operation: () =>
                service.Operation.applyMessageActionOperation(
                    service.Factory.applyMessageActionJsonRequest({
                        Header: getJsonRequestHeader(),
                        Body: createApplyMessageRequest(personaIds, service.Factory),
                    }),
                    fullResponseOperationOption
                ),
            transformResponse: response => response,
        })
    );
}
